import { useEffect } from 'react';
import { getPixallId } from '@atc/pixall-fns';
import { BrowserStorage } from '@atc/browser-storage';
import { useDispatch, useSelector } from 'react-redux';
import _isEqual from 'lodash/isEqual';
import { eventBus } from '@atc/cai-event-bus';
import { WALLET_GET_KBB_TRADE_INS_COMPLETED, WALLET_GET_KBB_TRADE_INS_REQUEST } from 'wallet-manager';
import { useFeatures } from 'reaxl-features';
import { usePrevious } from '@atc/use-previous';

// TODO: Remove the browser storage once find-car moves MyWalletContainer to _app.js, then we can use refs instead
const cbhCache = /* #__PURE__*/new BrowserStorage('CBH_LAST_FETCHED', {
  persist: true
});
const useKBBTradeInInitialization = _ref => {
  let {
    paymentsDuck,
    blockTradeInFetch = false
  } = _ref;
  const dispatch = useDispatch();
  const isPaymentsInfoLoaded = useSelector(paymentsDuck.selectors.getIsPaymentsInfoLoaded);
  const {
    configs: myWalletConfigs
  } = useSelector(paymentsDuck.selectors.getMyWallet) || {};
  const cbhTradeIns = useSelector(state => state?.cbhData?.kbbTradeIns) || [];
  const {
    wallet_trade_in_fetch: [enableTradeInFetch]
  } = useFeatures(['wallet_trade_in_fetch']);
  function updateKbbTradeIns() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (Object.keys(data).length) {
      dispatch(paymentsDuck.creators.updateUserTradeIn(data, true));
    }
  }
  useEffect(() => {
    eventBus.on(WALLET_GET_KBB_TRADE_INS_COMPLETED, updateKbbTradeIns);
    return () => {
      eventBus.off(WALLET_GET_KBB_TRADE_INS_COMPLETED, updateKbbTradeIns);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const previousCbhTradeIns = usePrevious(cbhTradeIns);
  useEffect(() => {
    if (enableTradeInFetch && isPaymentsInfoLoaded) {
      // need this state variable so that the fetch does not fire twice when navigating between the srp and vdp
      // (srp -> vdp navigation causes listing state change on the srp listing click AND vdp load, causing this useEffect to run twice)
      const cbhLastFetched = cbhCache.getItem() || 0;
      const timeSinceLastFetched = Date.now() - cbhLastFetched;
      // Need to space out calls to CBH
      if (timeSinceLastFetched > 120000 || !_isEqual(cbhTradeIns, previousCbhTradeIns)) {
        const pixAllId = getPixallId() || 'nl';
        eventBus.emit(WALLET_GET_KBB_TRADE_INS_REQUEST, {
          pixAllId,
          myWalletConfigs,
          cbhTradeIns,
          blockTradeInFetch
        });
        cbhCache.setItem(Date.now());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaymentsInfoLoaded, cbhTradeIns]);
  return null;
};
export { useKBBTradeInInitialization as default };
